import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../selectors/userSelectors";
import { configureCrisp, identifyCrispFromProfile } from "../utils/crisp";
import { fetchSupportProfile } from "../processes/supportProfileProcesses";

// Loads the Crisp widget and identifies the logged-in user with the data the
// support team needs. Mounted inside the authenticated LMS shell, so it only
// runs for logged-in users. Re-fetches when the current course changes.
export default function useCrispIntegration() {
  const currentUser = useSelector(getCurrentUser);
  const currentCourseId = useSelector((state) => state.currentCourseId);
  const userId = currentUser?.id;

  useEffect(() => {
    if (!userId) return;

    fetchSupportProfile(currentCourseId).then(({ data, meta }) => {
      configureCrisp(meta?.crispWebsiteId);
      identifyCrispFromProfile(data);
    });
  }, [userId, currentCourseId]);
}
